import { render, staticRenderFns } from "./NewTransferView.vue?vue&type=template&id=59d2f48a&scoped=true"
import script from "./NewTransferView.vue?vue&type=script&lang=ts"
export * from "./NewTransferView.vue?vue&type=script&lang=ts"
import style0 from "./NewTransferView.vue?vue&type=style&index=0&id=59d2f48a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d2f48a",
  null
  
)

export default component.exports